const firebaseConfig = {
  apiKey: "AIzaSyDHrPlTT7HftDUzXOja06jeaaip1jNVVMc",
  authDomain: "omaha-food-lovers-d64de.firebaseapp.com",
  projectId: "omaha-food-lovers-d64de",
  storageBucket: "omaha-food-lovers-d64de.firebasestorage.app",
  messagingSenderId: "17337558199",
  appId: "1:17337558199:web:fcd44574a06c166e209932",
  measurementId: "G-GC7C0XNWQX"
};

export default firebaseConfig;
